<template>
<div>
    <h3>Hola mundo!</h3>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
